import { useStore } from '../app/store';
import { Icon } from '../ui/icons';

export function About() {
  const S = useStore(), s = S.state.settings, P = s.property;
  const facts: [string, string][] = [['1 acre', 'private grounds'], [`${P.eventCapacity}`, 'guests for events'], [(() => { const h = s.packages.filter(p => p.kind === 'stay').sort((a, b) => b.capacity - a.capacity)[0]; return h ? `${h.capacity}–${h.max ?? h.capacity}` : `${P.houseCapacity}`; })(), 'guests for a house stay'], [P.city.split(',')[0]!, P.city.split(',').slice(1).join(',').trim() || 'location']];
  const edit = (section: string) => S.nav('settings', { s: section });
  return (
    <div className="page wide">
      <section className="about-hero" style={{ backgroundImage: `linear-gradient(100deg, rgba(31,52,52,0.92) 0%, rgba(47,79,79,0.65) 45%, rgba(47,79,79,0.1) 100%), url(assets/house-path.jpg)` }}>
        <div style={{ maxWidth: 560 }}>
          <div className="kicker-sm" style={{ color: 'var(--light-blue)' }}>About us</div>
          <h1 style={{ fontSize: 44, color: 'var(--beige)', margin: '6px 0 10px' }}>{P.name}</h1>
          <p style={{ color: '#e9efe6', fontSize: 15, lineHeight: 1.6, margin: 0 }}>{P.description}</p>
          <div style={{ display: 'flex', gap: 8, marginTop: 16, flexWrap: 'wrap' }}>
            <button className="btn sky" onClick={() => edit('property')}><Icon name="edit" size={14} />Edit details</button>
          </div>
        </div>
      </section>
      <div className="kpis" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))' }}>
        {facts.map(([a, b]) => <div key={b} className="kpi"><div className="val" style={{ fontFamily: 'var(--font-heading)', fontSize: 26 }}>{a}</div><div className="note">{b}</div></div>)}
      </div>
      <div className="cal-layout" style={{ gridTemplateColumns: 'minmax(0,1fr) 320px' }}>
        <section className="card">
          <div className="section-head"><h3 className="card-sub">Gallery</h3><button className="btn small" onClick={() => edit('property')}>Manage photos</button></div>
          <div className="mosaic">{P.gallery.map((g, i) => <figure key={g.src + i} className={i === 0 ? 'big' : ''}><img src={g.src} alt={g.cap} loading="lazy" /><figcaption>{g.cap}</figcaption></figure>)}</div>
        </section>
        <div className="col">
          <section className="card">
            <h3 className="card-sub" style={{ marginBottom: 8 }}>Contact</h3>
            <div className="kv">
              <div><span>Owner</span><span>{P.owner}</span></div>
              <div><span>Phone</span><span>{P.phone}</span></div>
              <div><span>WhatsApp</span><span>{P.whatsapp}</span></div>
              <div><span>Email</span><span>{P.email}</span></div>
              <div><span>UPI</span><span>{P.upi}</span></div>
              <div><span>Caretaker</span><span>{P.caretaker}</span></div>
              <div><span>Address</span><span>{P.address}, {P.city}</span></div>
            </div>
          </section>
          <section className="card">
            <h3 className="card-sub" style={{ marginBottom: 10 }}>Amenities</h3>
            <div className="chips">{P.amenities.map(a => <span key={a} className="chip">{a}</span>)}</div>
          </section>
          <section className="card">
            <div className="section-head"><h3 className="card-sub">Good to know</h3><button className="btn small" onClick={() => edit('rules')}>Edit rules</button></div>
            {([['Property', s.rules.property], ['House', s.rules.house], ['Pool', s.rules.pool]] as const).map(([k, list]) => (
              <div key={k} style={{ marginTop: 10 }}><b style={{ fontSize: 13.5 }}>{k} rules · {list.length}</b><div className="muted" style={{ fontSize: 12.5 }}>{list[0]}</div></div>
            ))}
          </section>
        </div>
      </div>
    </div>
  );
}
